import React from 'react';

interface MakeItYoursPanelProps {
	siteName?: string;
	onRenameSite: () => void;
	onOpenLocations: () => void;
	onAddSite: () => void;
	onDismiss: () => void;
}

interface Shortcut {
	label: string;
	detail: string;
	onClick: () => void;
}

// Shown above the results of a starter site that still has default names (PWA-3011, mockup C).
const MakeItYoursPanel: React.FC<MakeItYoursPanelProps> = ({
	siteName,
	onRenameSite,
	onOpenLocations,
	onAddSite,
	onDismiss,
}) => {
	const shortcuts: Shortcut[] = [
		{ label: 'Rename site', detail: siteName ?? '', onClick: onRenameSite },
		{ label: 'Rename or add locations', detail: 'Every point you sample', onClick: onOpenLocations },
		{ label: 'Add another site', detail: 'And group them (optional)', onClick: onAddSite },
	];

	return (
		<aside
			aria-labelledby="make-it-yours-title"
			className="mx-6 mt-5 mb-1 py-[18px] px-5 border border-[#ECEDEF] rounded bg-[#F4F8F9] flex flex-col gap-3"
		>
			<div className="flex items-start gap-4">
				<div className="min-w-0 flex-1 flex flex-col gap-1 break-words">
					<h2 id="make-it-yours-title" className="m-0 font-inter text-[16px] font-semibold tracking-normal text-[#2C2C2C]">
						Your first result is in. Now make the site yours.
					</h2>
					<p className="m-0 font-jost text-[15px] leading-[22px] text-[#556670]">
						Real names make exports and reports easier to read. Your results stay attached when you rename.
					</p>
				</div>
				<button
					type="button"
					onClick={onDismiss}
					className="shrink-0 p-[6px] bg-transparent border-0 font-inter text-[14px] font-semibold text-[#556670] hover:text-[#2C2C2C] cursor-pointer focus-visible:outline focus-visible:outline-2 focus-visible:outline-[#0093C8]"
				>
					Dismiss
				</button>
			</div>
			<ul className="list-none m-0 p-0 grid grid-cols-[repeat(auto-fit,minmax(min(100%,200px),1fr))] gap-[10px]">
				{shortcuts.map((shortcut) => (
					<li key={shortcut.label} className="min-w-0">
						<button
							type="button"
							onClick={shortcut.onClick}
							className="w-full h-full py-3 px-[14px] border border-[#9EACB4] rounded-sm bg-white text-left cursor-pointer flex flex-col gap-[2px] hover:bg-[#F4FCFF] focus-visible:outline focus-visible:outline-2 focus-visible:outline-[#0093C8]"
						>
							<span className="max-w-full break-words font-inter text-[14px] font-semibold text-[#007AA7]">{shortcut.label}</span>
							<span className="font-jost text-[14px] text-[#556670] truncate max-w-full">{shortcut.detail}</span>
						</button>
					</li>
				))}
			</ul>
		</aside>
	);
};

export default MakeItYoursPanel;
